// Assets relating to the shop
import "../img/icons/cart-icon-light.svg";
import "../img/icons/cart-icon-dark.svg";
